module.exports = __webpack_public_path__ + "static/media/iStock-848174010.19c11040.jpg";